const ReclaimedOfferStatus =
    {
        Offered : 0,
        Withdrawn : 1,
        WaitingForBuyerFunds : 2,
        Sold : 99,
    }

    export default ReclaimedOfferStatus;